module.exports = __webpack_public_path__ + "img/c_802.ac180249.jpg";